export const PAGE_PATH = '/project';
